import React from 'react';
import {signOut} from 'firebase/auth';
import {VscSignOut} from 'react-icons/vsc';
import {auth} from '../../firebase';

const style = {
	container: `flex justify-center   p-4`,
	signoutButton: `text-whirlwindRed hover:text-whirlwindRedDark   opacity-90`,
};

export const SignoutButton = () => {
	// Component methods
	const genericSignout = async () => {
		await signOut(auth);
	};

	return (
		<div className={style.container}>
			<button
				className={style.signoutButton}
				data-test-id={`signoutButton_TEST`}
				onClick={genericSignout}
				type="button">
				<VscSignOut size={72} />
			</button>
		</div>
	);
};
